import type { FC, PropsWithChildren } from 'react'

import { ConsentSettingsDrawer } from './common'
import { useAccommodationContextChangeTracking, useGlobalIdTracking } from './hooks'

type AnalyticsProps = PropsWithChildren

export const Analytics: FC<AnalyticsProps> = ({ children }) => {
  useAccommodationContextChangeTracking()
  useGlobalIdTracking()

  return (
    <>
      {children}
      <ConsentSettingsDrawer />
    </>
  )
}
